export const init = () => {
  if (tc_vars.env_template !== 'checkout') return;

  const fwk = CUBE.Analytics;

  const event = CUBE.Analytics.utils.getEvent('confirmModifyProduct');
  if (event) {
    event.postAction($element => {
      const $product = $element.closest('.faux-table-wrapper');
      let model = fwk.utils.basketpage.getModel($product);
      fwk.enhanced.setModelVada(model); // set 'model.category' with 'model.vada{}' info (if any)

      let modelId;
      if (!model) {
        const refId = $product.find('[product-id]').attr('product-id');
        modelId = $product.find('[model-id]').attr('model-id');
        model = fwk.utils.datalayer.getModel(refId);
      } else {
        modelId = model.id;
      }
      let price = model.price;

      const confirmModel = $('#confirm_modification')
        .parents('.modify-product-wrapper')
        .find('.model-selection.slick-current');
      if (confirmModel.length > 0) {
        modelId = confirmModel.data('model-id');
        const confirmVariant = $product.find(
          '.size-wrap.selected select.size-selection-list option.selected'
        );
        if (confirmVariant.length > 0) {
          price = confirmVariant.data('price');
        }
      }

      model.list = '/checkout/cart';
      const quantity = parseFloat($product.find('.quantity-input').val());

      // Save the new EC in the ENHANCED storage and send AddToCart
      fwk.enhanced.set({
        id: modelId,
        position: model.position,
        list: model.list,
        quantity,
        variant: model.variant,
        price,
        category: model.category,
        vada: model.vada,
        name: model.name,
        brand: model.brand,
      });
      fwk.enhanced.sendAddToCart(fwk.enhanced.get());
    });
  }
};



// WEBPACK FOOTER //
// ./src/analytics/enhanced/ec-add-modifyproduct.js